import { render, staticRenderFns } from "./informational.vue?vue&type=template&id=4b100187&"
import script from "./informational.vue?vue&type=script&lang=ts&"
export * from "./informational.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports